<div class="uploader-card">
  <div class="ticket" [class.has-file]="previewDataUrl && resultBytes > 0">
    <div class="ticket-inner" (click)="fileInput.click()">

      <!-- Icono nube -->
      <div class="cloud">
        <mat-icon>cloud_upload</mat-icon>
      </div>

      <!-- Titulos -->
      <h3 class="title">ELIGE O ARRASTRA Y SUELTA AQUI</h3>
      <p class="subtitle">Click o suelta una imagen</p>

      <!-- Zona de nombre + boton eliminar -->
      <div class="dropline" *ngIf="previewDataUrl && resultBytes > 0">
        <span class="file-name">
          {{ file ? file.name : 'Imagen cargada' }}
        </span>

        <button
          mat-raised-button
          color="warn"
          class="btn-delete"
          (click)="$event.stopPropagation(); clearFile()">
          ELIMINAR
        </button>
      </div>

      <!-- Vista previa -->
      <div *ngIf="previewDataUrl && resultBytes > 0"
           class="preview-wrap"
           (click)="$event.stopPropagation()">
        <img
          [src]="previewDataUrl"
          [class.circle]="circle"
          alt="Vista previa"
          class="preview-img" />
        <div class="kb">{{ getKB(resultBytes) }} KB</div>
      </div>

      <!-- Input real (oculto) -->
      <input
        #fileInput
        class="file-input"
        type="file"
        [attr.accept]="acceptedTypes"
        (change)="onFileSelected($event)"
        aria-autocomplete="none"
        autocomplete="off" />
    </div>
  </div>
</div>
